module.exports = __webpack_public_path__ + "static/key-rapture-89e87fb2125c445968b38f3310f78543.webp";